<template>
  <div>
    <div class="form-row div-valign">
      <div class="form-group col-md-4">
        <label>ระยะเวลาในการค้ำประกัน</label>
        <b-form-radio
          v-model="extperiodType"
          v-bind:value=2
          name="extperiodType"
          v-validate="{required:true}"
        >มีกำหนดระยะเวลา</b-form-radio>
      </div>
      <div class="form-group no-label col-md-4">
        <div class="form-row">
          <label>ตั้งแต่วันที่</label>
          <date-picker
            v-model="extperiodStartDate1"
            name="extperiodStartDate1"
            ref="extperiodStartDate1"
            lang="th"
            format="DD/MM/YYYY"
            :disabled="true"
            :not-after="this.extperiodEndDate"
            :not-before="this.tmpStartDate1"
            placeholder
            v-validate="{ required: this.extperiodType ===2 }"
            data-vv-as="ตั้งแต่วันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodStartDate1') }"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodStartDate1')}"
          >{{ errors.first('extperiodStartDate1') }}</span>
        </div>
      </div>

      <div class="form-group no-label col-md-4">
        <div class="form-row">
          <label>ถึงวันที่</label>
          <date-picker
            v-model="extperiodEndDate"
            name="extperiodEndDate"
            ref="extperiodEndDate"
            lang="th"
            format="DD/MM/YYYY"
            :defaultValue="this.defaultEndDateValue"
            :disabled="this.extperiodType !== 2"
            :not-before="new Date()>this.extperiodStartDate1?new Date():this.extperiodStartDate1"
            placeholder
            v-validate="{ required: this.extperiodType ===2 }"
            data-vv-as="ตั้งแต่วันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodEndDate') }"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodEndDate')}"
          >{{ errors.first('extperiodEndDate') }}</span>
        </div>
      </div>
    </div>

    <div class="form-row div-valign">
      <div class="form-group no-label col-md-3">
        <b-form-radio
          v-model="extperiodType"
          name="extperiodType"
          v-bind:value=1
          v-validate="{required:true}"
        >ไม่มีกำหนดระยะเวลา</b-form-radio>
      </div>

      <div class="form-group no-label col-md-2"><label>ตั้งแต่วันที่</label></div>
      <div class="form-group no-label col-md-3">
        <div class="form-row">
          <date-picker
            v-model="extperiodStartDate2"
            name="extperiodStartDate2"
            ref="extperiodStartDate2"
            lang="th"
            format="DD/MM/YYYY"
            placeholder
            :disabled="true"
            v-validate="{ required: this.extperiodType ===1 }"
            data-vv-as="ตั้งแต่วันที่"
            :class="{'input': true, 'is-danger': errors.has('extperiodStartDate2') }"
          ></date-picker>
          <span
            class="form-error"
            :class="{'text-danger': errors.has('extperiodStartDate2')}"
          >{{ errors.first('extperiodStartDate2') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  inject: ["$validator"],
  props: ["reqType","oldperiodEndDate"],
  data() {
    return {
      extperiodType: "",
      extperiodStartDate1: "",
      extperiodStartDate2: "",
      extperiodEndDate: "",
      tmpStartDate1:"",
      defaultEndDateValue:this.defaultEndDate(),
    };
  },
  mounted() {

    if(typeof this.oldperiodEndDate === 'object'){
      this.extperiodStartDate1 = this.addDays(this.oldperiodEndDate,1);
      this.extperiodStartDate2 = this.addDays(this.oldperiodEndDate,1);
      this.tmpStartDate1 = this.extperiodStartDate1;
    }
  },
  methods: {
    defaultEndDate:function(){
      let newDeaultEndDate = new Date();
      if(typeof this.oldperiodEndDate === 'object'){
        newDeaultEndDate = this.addDays(this.oldperiodEndDate,1);        
      }
      return newDeaultEndDate;
    },

    addDays:function(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },

  },
  watch: {
    extperiodType(newval, oldval) {
      Promise.all([
        this.$validator.validate('extperiodStartDate1'),
        this.$validator.validate('extperiodStartDate2'),
        this.$validator.validate('extperiodEndDate'),
      ]);

      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
      });
    },
    extperiodStartDate1(newDate, oldDate) {
      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,    
      });
    },
    extperiodStartDate2(newDate, oldDate) {
      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
 
      });
    },
    extperiodEndDate(newDate, oldDate) {

      this.$emit("onChildExtIncChange", {
        extperiodType: this.extperiodType,
        extperiodStartDate1: this.extperiodStartDate1,
        extperiodStartDate2: this.extperiodStartDate2,
        extperiodEndDate: this.extperiodEndDate,
      });
    }    
  }  
};
</script>